import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'

export const toggleLabels = createActionCreator(actions.TOGGLE_LABELS)



// WEBPACK FOOTER //
// ./src/actionCreators/labels.js